import {
  CreateWikiArticleRequest,
  CreateWikiTagRequest,
  PaginatedWikiArticles,
  UpdateWikiArticleRequest,
  UpdateWikiTagRequest,
  WikiArticle,
  WikiArticleFilters,
  WikiArticleRevision,
  WikiAttachment,
  WikiTag,
} from "@/types/wiki";

import { kyInstance } from "@/api/api-config";

// Articles
export async function getWikiArticles(
  filters: WikiArticleFilters,
): Promise<PaginatedWikiArticles> {
  const searchParams: Record<string, string | number | boolean> = {
    page: filters.page,
    page_size: filters.pageSize,
    sort_by: filters.sortBy,
    sort_direction: filters.sortDirection,
  };
  if (filters.search) searchParams.search = filters.search;
  if (filters.isPublished !== undefined)
    searchParams.is_published = filters.isPublished;
  if (filters.articleType) searchParams.article_type = filters.articleType;

  return kyInstance.get("wiki/articles", { searchParams }).json();
}

export async function getWikiArticle(articleId: string): Promise<WikiArticle> {
  return kyInstance.get(`wiki/articles/${articleId}`).json();
}

export async function createWikiArticle(
  data: CreateWikiArticleRequest,
): Promise<WikiArticle> {
  return kyInstance.post("wiki/articles", { json: data }).json();
}

export async function updateWikiArticle(
  articleId: string,
  data: UpdateWikiArticleRequest,
): Promise<WikiArticle> {
  return kyInstance.patch(`wiki/articles/${articleId}`, { json: data }).json();
}

export async function deleteWikiArticle(articleId: string): Promise<void> {
  await kyInstance.delete(`wiki/articles/${articleId}`);
}

export async function getWikiArticleRevisions(
  articleId: string,
): Promise<WikiArticleRevision[]> {
  return kyInstance.get(`wiki/articles/${articleId}/revisions`).json();
}

// Attachments
export async function uploadWikiAttachments(
  articleId: string,
  files: File[],
): Promise<WikiAttachment[]> {
  const formData = new FormData();
  for (const file of files) {
    formData.append("files", file);
  }
  return kyInstance
    .post(`wiki/articles/${articleId}/attachments`, { body: formData })
    .json();
}

export async function deleteWikiAttachment(
  articleId: string,
  attachmentId: string,
): Promise<void> {
  await kyInstance.delete(
    `wiki/articles/${articleId}/attachments/${attachmentId}`,
  );
}

// Tags
export async function getWikiTags(): Promise<WikiTag[]> {
  return kyInstance.get("wiki/tags").json();
}

export async function createWikiTag(
  data: CreateWikiTagRequest,
): Promise<WikiTag> {
  return kyInstance.post("wiki/tags", { json: data }).json();
}

export async function updateWikiTag(
  tagId: string,
  data: UpdateWikiTagRequest,
): Promise<WikiTag> {
  return kyInstance.put(`wiki/tags/${tagId}`, { json: data }).json();
}

export async function deleteWikiTag(tagId: string): Promise<void> {
  await kyInstance.delete(`wiki/tags/${tagId}`);
}
